import classNames from 'classnames';

interface Props {
  size?: number;
  className?: string;
}

export default function MapPinPreviewIcon({ size = 24, className = 'text-brand-strong' }: Props) {
  return (
    <svg
      width={size}
      height={(size * 48) / 41}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="17 9 41 48"
      fill="none"
      className={classNames('fill-current', className)}
    >
      <path
        d="M24.2383 16.1651C27.8002 12.6497 32.6296 10.6723 37.667 10.6667C42.7043 10.6723 47.5338 12.6497 51.0957 16.1651C54.6577 19.6804 56.6613 24.4466 56.667 29.4181C56.667 43.3879 39.4535 54.8731 38.721 55.355C38.4081 55.5583 38.0417 55.6667 37.6671 55.6667C37.2925 55.6667 36.9261 55.5583 36.6132 55.355C35.8805 54.8731 18.667 43.3879 18.667 29.4181C18.6727 24.4466 20.6763 19.6804 24.2383 16.1651Z"
        fill="currentColor"
      />
      <path
        d="M58 29.4177C58 36.926 53.3995 43.611 48.9404 48.3571C44.4448 53.1421 39.8624 56.1998 39.4541 56.4684L39.4473 56.4733C38.9173 56.8176 38.2983 56.9997 37.667 56.9997C37.0357 56.9997 36.4167 56.8177 35.8867 56.4733L35.8809 56.4694C35.4745 56.2022 30.8905 53.1434 26.3936 48.3571C21.9345 43.611 17.334 36.926 17.334 29.4177V29.4167C17.3401 24.0865 19.4883 18.9801 23.3018 15.2165C27.1146 11.4536 32.2804 9.33983 37.665 9.33368H37.6689C43.0536 9.33983 48.2194 11.4536 52.0322 15.2165C55.8456 18.9801 57.9939 24.0865 58 29.4167V29.4177Z"
        stroke="#f9fafb"
        strokeOpacity="0.5"
        strokeWidth="2.66667"
      />
      <path
        d="M37.6603 18.3981C34.5882 18.3981 31.5161 19.5275 29.1684 21.7862C26.9146 23.9929 25.667 26.9137 25.667 30.0031C25.667 33.0926 26.9146 36.0263 29.1818 38.2201L37.6335 46.3981L37.6603 46.3722L37.6871 46.3981L40.0616 44.1005L37.6603 41.7899L31.5697 35.8965C29.9465 34.3258 29.0477 32.2229 29.0477 30.0031C29.0477 27.7834 29.9465 25.6934 31.5697 24.1098C33.2466 22.4742 35.4468 21.6564 37.6603 21.6564C39.8738 21.6564 42.0605 22.4742 43.7508 24.0968C45.3741 25.6675 46.2729 27.7704 46.2729 29.9902C46.2729 32.0022 45.5217 33.9104 44.1801 35.4162L46.5949 37.7528C48.5804 35.6239 49.667 32.8849 49.667 29.9902C49.667 26.8877 48.4194 23.967 46.1522 21.7732C43.8179 19.5405 40.7324 18.3981 37.6603 18.3981Z"
        fill="#ffffff"
      />
      <path
        d="M39.2211 31.6273L37.5401 33.2323L35.8591 31.6273C34.9422 30.7519 34.9422 29.306 35.8591 28.4306C36.3036 28.0061 36.901 27.7673 37.5401 27.7673C38.1791 27.7673 38.7765 28.0061 39.2211 28.4306C39.6657 28.855 39.9157 29.4254 39.9157 30.0356C39.9157 30.6325 39.6657 31.2028 39.2211 31.6273ZM40.0269 35.5934L41.7079 33.9884C44.0001 31.7998 44.0001 28.2316 41.7079 26.0429C40.5965 24.9818 39.1238 24.3981 37.554 24.3981C35.9841 24.4114 34.4976 24.995 33.3862 26.0562C31.0939 28.2449 31.0939 31.813 33.3862 34.0017L37.5401 37.9678L39.6934 40.0238L42.1802 42.3981L44.667 40.0238L42.1802 37.6494L40.0269 35.5934Z"
        fill="#ffffff"
      />
    </svg>
  );
}
